import axiosInstance from "./axios";

export const getConfigurationByTeamId = async (teamId: string) => {
  try {
    return await axiosInstance.get(`/config/team/${teamId}`);
  } catch (error) {
    throw error;
  }
};

export const updateTeamConfiguration = async (teamId: string, data: any) => {
  try {
    return await axiosInstance.put(`/config/team/${teamId}`, data);
  } catch (error) {
    throw error;
  }
};

export const getAllTeams = async (search: string = "") => {
  try {
    const response = await axiosInstance.get(
      `/config/super-admin/get-all-teams${
        search ? `?search=${encodeURIComponent(search)}` : ""
      }`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteTeamBySuperAdmin = async (teamId: string) => {
  try {
    return await axiosInstance.delete(
      `/config/super-admin/delete-team/${teamId}`
    );
  } catch (error) {
    throw error;
  }
};

export const updateCreditThreshold = async (
  teamId: string,
  creditThreshold: number
) => {
  try {
    return await axiosInstance.put(
      `/config/super-admin/credit-threshold/${teamId}`,
      { creditThreshold }
    );
  } catch (error) {
    throw error;
  }
};

export const getInfraCost = async () => {
  try {
    const response = await axiosInstance.get("/config/infra-cost");
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateInfraCost = async (cost: number) => {
  try {
    const response = await axiosInstance.put("/config/infra-cost", { cost });
    return response;
  } catch (error) {
    throw error;
  }
};
